import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 5000);
    const hideTimer = setTimeout(() => setIsVisible(false), 15000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-286">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-287">
          <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-4 pr-10 relative overflow-hidden" data-id="element-288">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-emerald-500" data-id="element-289"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 p-1" aria-label="Cerrar notificación" data-id="element-290">
              <X className="w-4 h-4" data-id="element-291" />
            </button>

            <div className="flex items-start gap-3" data-id="element-292">
              <div className="mt-0.5 shrink-0" data-id="element-293">
                <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-294" />
              </div>
              <div data-id="element-295">
                <p className="text-xs font-bold text-emerald-600 uppercase tracking-wider mb-1" data-id="element-296">
                  Compra verificada
                </p>
                <p className="text-sm text-slate-700 leading-tight" data-id="element-297">
                  <strong data-id="element-298">Florencia B.</strong> de La Plata compró
                  <br data-id="element-299" />
                  <span className="text-sky-700 font-medium" data-id="element-300">
                    Megapack + Sistema Maestro 🌱
                  </span>
                </p>
                <p className="text-xs text-slate-400 mt-2" data-id="element-301">Hace 2 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}